import React from 'react';
import type { ColDef, EditableCallbackParams } from 'ag-grid-community';
import { LopCrudPage } from '../../components/LopCrudPage';
import {
  getBenchmarkRates,
  saveBenchmarkRatesBatch,
} from '../../api/benchmarkRates';
import type { BenchmarkRate } from '../../types/BenchmarkRate';
import { t } from '../../i18n/t';

const benchmarkRatesColumnDefs: ColDef<BenchmarkRate>[] = [
  {
    field: 'benchmarkRateId',
    headerName: t('benchmarkRates.columns.benchmarkRateId'),
    width: 120,
    // Natural PK: editable on Add only; existing rows must keep their id.
    editable: (params: EditableCallbackParams<BenchmarkRate>) =>
      (params.data as { __status?: string } | undefined)?.__status === 'added',
    cellDataType: 'number',
    sort: 'asc',
  },
  {
    field: 'benchmarkRateName',
    headerName: t('benchmarkRates.columns.benchmarkRateName'),
    flex: 1,
    editable: true,
  },
];

const newBenchmarkRateDefaults = (): Partial<BenchmarkRate> => ({
  benchmarkRateId: 0,
  benchmarkRateName: '',
});

export function BenchmarkRatesPage() {
  return (
    <LopCrudPage<BenchmarkRate>
      resourceCode="benchmarkRates"
      titleKey="benchmarkRates.pageTitle"
      idField="benchmarkRateId"
      getRows={getBenchmarkRates}
      saveBatch={(added, modified, deletedIds) =>
        saveBenchmarkRatesBatch(added, modified, deletedIds as number[])
      }
      columnDefs={benchmarkRatesColumnDefs}
      newRowDefaults={newBenchmarkRateDefaults}
    />
  );
}
